import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  position: relative;
  padding-top: 70px;
  width: 100%;
  min-height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContainerForm = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 10px auto;
  padding: 40px;
  width: 60%;
  background-color: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);

  @media (max-width: 1366px) {
    width: 80%;
  }

  @media (max-width: ${Variables.maxMobile}) {
    flex-direction: column;
    width: 90%;
  }
`;

export const Left = styled.div`
  position: relative;
  width: 35%;

  @media (max-width: ${Variables.maxMobile}) {
    width: 100%;
  }
`;

export const Right = styled.div`
  width: 60%;

  @media (max-width: ${Variables.maxMobile}) {
    width: 100%;
  }
`;

export const TextInterest = styled.p`
  font-size: 20px;
  text-align: center;
  font-weight: bold;
`;

export const ContainerLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;
export const Content = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const AnimationLoading = styled.div`
  display: inline-block;
  align-self: center;
  width: 80px;
  height: 80px;

  & :after {
    content: " ";
    display: block;
    margin: 8px;
    width: 64px;
    height: 64px;
    border: 6px solid ${Variables.colorPrimary};
    border-radius: 50%;
    border-color: ${Variables.colorPrimary} transparent ${Variables.colorPrimary} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ContainerPagination = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #2959fb;
  cursor: pointer;

  :hover {
    color: #072fb8;
    text-decoration: underline;
  }
`;
